// Restaurant config — single source of truth.

export const ASSETS = {
  // Brand
  logo:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/eiqogpqn_Screenshot_20260607_003305_TikTok.jpg",
  // Exteriors
  storefront:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/lfhtocec_IMG-20260514-WA0029.jpg",
  shawarmaGrills:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/traq3epw_IMG-20260514-WA0027.jpg",
  // Dishes
  jollofSeafood:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/25dh82nx_IMG-20260521-WA0013.jpg",
  jollofTray:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/0hvds03b_IMG-20260521-WA0039.jpg",
  jollofVeggiePlate:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/tf33t0bm_IMG-20251213-WA0063.jpg",
  afangSoup:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/y3ewgbzj_IMG-20260313-WA0064.jpg",
  bitterLeafSoup:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/gna4srul_levgz8h1_IMG-20251213-WA0086.jpg",
  pepperSoup:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/0fnn51it_IMG-20260313-WA0069.jpg",
  goatMeatStew:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/xvjika2d_IMG-20251213-WA0066.jpg",
  vegetableChicken:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/oyvnjgmk_5mkh30v2_IMG-20251213-WA0087.jpg",
  suyaSkewers:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/722dhnwr_IMG-20251222-WA0023.jpg",
  shawarmaPress:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/614tq6iu_rp2x3b34_IMG-20251213-WA0071.jpg",
  barbecueFishPlantain:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/yk7o54k4_ttcfmmsn_IMG-20260129-WA0014.jpg",
  barbecueFishGrill:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/g8cqmjry_IMG-20251222-WA0019.jpg",
  abacha:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/ik3sj2gi_004lz8i7_IMG-20251213-WA0076.jpg",
  akaraCustard:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/4dotkgaj_IMG-20260319-WA0071.jpg",
  breakfastTray:
    "https://customer-assets.emergentagent.com/job_awka-eats/artifacts/trph1ztn_IMG-20260102-WA0025.jpg",
};

export const RESTAURANT = {
  name: "Meritz Restaurant",
  tagline: "To eat is to live...",
  address: "No 5 Figo Plaza, Okpuno (along Goodwill Junction), Awka, Anambra",
  shortAddress: "No 5 Figo Plaza, Okpuno · Awka",
  phoneDisplay: "+234 808 167 8041",
  phoneRaw: "+2348081678041",
  whatsappNumber: "2348081678041",
  hours: [
    { day: "Open daily", time: "9:00 AM — 10:00 PM" },
    { day: "Orders start", time: "10:00 AM" },
  ],
  socials: {
    tiktok: "https://www.tiktok.com/@meritz_restaurant",
    tiktokHandle: "@meritz_restaurant",
    instagram: "https://instagram.com/meritfoodie",
    instagramHandle: "@meritfoodie",
    facebook: "https://facebook.com/meritfoodie",
    facebookHandle: "Merit Foodie",
  },
  promo: {
    headline: "20% OFF on every 5th order",
    sub: "Stay loyal — your 5th order gets 20% off, automatically.",
  },
  delivery: {
    feeMin: 1500,
    feeMax: 3000,
    note: "Delivery ₦1,500 – ₦3,000, depending on your location.",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=Figo+Plaza+Okpuno+Goodwill+Junction+Awka&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Figo+Plaza+Okpuno+Goodwill+Junction+Awka+Anambra",
};

export const waLink = (msg = "Hello Meritz! I'd like to place an order.") =>
  `https://wa.me/${RESTAURANT.whatsappNumber}?text=${encodeURIComponent(msg)}`;
